import { type ApiResponse } from "apisauce"

import { request } from "../../../services/api.ts"
import type { BaseApiResponse } from "../../../types/api.ts"

const PATH = "/subcontractor/alert-settings/"

export interface SubcontractorAlertSettings {
  /** The company-wide default; null means "not set", read as the built-in default. */
  subcontractor_compliance_alert_lead_days: number | null
  /** Days per document type; a type with no entry uses the default. */
  subcontractor_compliance_alert_lead_days_by_type: Record<string, number>
  built_in_default_days: number
}

export type SubcontractorAlertSettingsPayload = Pick<
  SubcontractorAlertSettings,
  | "subcontractor_compliance_alert_lead_days"
  | "subcontractor_compliance_alert_lead_days_by_type"
>

export const getSubcontractorAlertSettings = (): Promise<
  ApiResponse<SubcontractorAlertSettings>
> => request.api.get(PATH)

// A PATCH response is enveloped by the backend's EnvelopeJSONRenderer
// (`{status, details: {..., data}}`) — the caller reads the saved values
// back from a successful save, so the envelope has to be modeled here
// rather than silently ignored (GET above is never enveloped).
export const updateSubcontractorAlertSettings = (
  payload: SubcontractorAlertSettingsPayload
): Promise<ApiResponse<BaseApiResponse<SubcontractorAlertSettings>>> =>
  request.api.patch(PATH, payload)
